import "core-js/modules/es.object.from-entries.js";
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { AllMenusQuery, Link, Locale, useLocation } from "@custom/schema";
import { CloseButton, Dialog, DialogPanel, Disclosure, DisclosureButton, DisclosurePanel, Listbox, ListboxButton, ListboxOption, ListboxOptions, Popover, PopoverButton, PopoverPanel, Select, Transition } from "@headlessui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import clsx from "clsx";
import { AnimatePresence, motion } from "motion/react";
import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { ChevronDown, ChevronLeft, ChevronRight, ChevronsDown, Search, X } from "react-feather";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useMeasure from "react-use-measure";
import { z } from "zod";
import { useDomain } from "../../../utils/domain";
import { useLocalization } from "../../../utils/localization";
import { menuItems } from "../../../utils/navigation";
import { useOperation } from "../../../utils/operation";
import { usePageTranslations } from "../../../utils/page-translations";
import { useSearchForm } from "../../../utils/search";
import { getContactUrl, getLocalizedUrl } from "../../../utils/url";
import { useCallToAction } from "../../../utils/useCallToAction";
import { LinkClickHandler } from "../../Atoms/LinkClickHandler";
import { Logo, LogoCompactSvg } from "../../Atoms/Logo";
import { StickyCTA } from "../../Atoms/StickyCTA";
import { HeaderCTAs } from "./HeaderCTAs";
var DesktopSearchContent = function DesktopSearchContent(param) {
  var setIsSearchOpen = param.setIsSearchOpen,
    isSearchOpen = param.isSearchOpen,
    close = param.close;
  var t = useTranslation().t;
  var _useSearchForm = _sliced_to_array(useSearchForm(), 2),
    _onSubmit = _useSearchForm[0],
    register = _useSearchForm[1];
  var domain = useDomain();
  useEffect(function () {
    setIsSearchOpen(isSearchOpen);
  }, [isSearchOpen]);
  return /*#__PURE__*/React.createElement(PopoverPanel, {
    static: true,
    className: "absolute top-0 inset-x-5 -z-[1]"
  }, /*#__PURE__*/React.createElement(AnimatePresence, null, isSearchOpen && /*#__PURE__*/React.createElement(motion.div, {
    className: "shadow-nav-flyout overflow-hidden rounded-b-20 bg-primary-beige-light",
    initial: "initialMenu",
    animate: "openMenu",
    exit: "closedMenu",
    variants: {
      initialMenu: {
        height: 0,
        opacity: 0
      },
      openMenu: {
        height: "auto",
        opacity: 1,
        transition: {
          type: "spring",
          stiffness: 150,
          damping: 15,
          delay: 0
        }
      },
      closedMenu: {
        height: 0,
        opacity: 0,
        transition: {
          duration: 0.4,
          type: "tween",
          opacity: {
            delay: 0.2
          }
        }
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content pt-56 pb-36 items-center justify-center flex flex-col gap-3.5 px-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-5 items-center w-full"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-20 font-bold font-juneau leading-125% text-primary-black"
  }, t("header.search.title")), /*#__PURE__*/React.createElement("form", {
    method: "GET",
    className: "w-[40rem]",
    onSubmit: function onSubmit(e) {
      _onSubmit(e);
      close();
    }
  }, /*#__PURE__*/React.createElement("label", {
    className: "sr-only",
    htmlFor: "site-search"
  }, t("header.search.label")), /*#__PURE__*/React.createElement("div", {
    className: "primary-black h-14 text-18 leading-160% ps-7 justify-between items-center inline-flex border-2 border-primary-black bg-primary-white rounded-full w-full text-primary-black gap-2"
  }, /*#__PURE__*/React.createElement("input", _object_spread_props(_object_spread({
    id: "site-search",
    type: "text",
    className: "border-0 bg-transparent p-0 placeholder:text-primary-black focus:border-0 focus:ring-0 w-full",
    placeholder: t("header.search.placeholder")
  }, register("search")), {
    autoFocus: true
  })), domain.id !== "paraplegie_ch" && /*#__PURE__*/React.createElement("input", _object_spread({
    type: "hidden"
  }, register("domain"))), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "rounded-full bg-theme-action text-primary-white min-w-[50px] h-[50px] w-[50px] flex items-center justify-center m-[1px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, t("header.search.button")), /*#__PURE__*/React.createElement(Search, {
    className: "h-6 w-6",
    "aria-hidden": true
  })))), /*#__PURE__*/React.createElement("p", {
    className: "text-14 leading-160% text-primary-black"
  }, t("header.search.description")))))));
};
var SearchForm = function SearchForm(props) {
  var t = useTranslation().t;
  var _useSearchForm = _sliced_to_array(useSearchForm(), 2),
    _onSubmit2 = _useSearchForm[0],
    register = _useSearchForm[1];
  var domain = useDomain();
  return /*#__PURE__*/React.createElement("div", {
    className: "text-primary-black h-12 text-16 leading-160% px-4.5 justify-between items-center inline-flex border-2 border-primary-black bg-primary-white rounded-full mb-4 focus-within:outline-primary-black focus-within:outline-2 focus-within:outline focus-within:outline-offset-2 body-has-theme-[default]:mt-3.5 w-full"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      _onSubmit2(e);
      props.onSubmit();
    },
    method: "GET",
    className: "w-full"
  }, /*#__PURE__*/React.createElement("label", {
    className: "sr-only",
    htmlFor: "site-search"
  }, t("header.search.label")), /*#__PURE__*/React.createElement("input", _object_spread({
    id: "site-search",
    type: "text",
    className: "border-0 bg-transparent p-0 placeholder:text-primary-black focus:border-0 focus:ring-0 w-full",
    placeholder: t("header.search.button")
  }, register("search"))), domain.id !== "paraplegie_ch" && /*#__PURE__*/React.createElement("input", _object_spread({
    type: "hidden"
  }, register("domain"))), /*#__PURE__*/React.createElement("button", {
    className: "sr-only",
    type: "submit"
  }, t("header.search.button"))), /*#__PURE__*/React.createElement(Search, {
    className: "h-4 w-4 stroke-[3]",
    "aria-hidden": true
  }));
};
var DesktopSearch = function DesktopSearch(param) {
  var setIsSearchOpen = param.setIsSearchOpen;
  var t = useTranslation().t;
  return /*#__PURE__*/React.createElement(Popover, null, function (param) {
    var open = param.open,
      close = param.close;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PopoverButton, {
      className: "text-primary-white hover:bg-primary-white rounded-full hover:text-primary-black transition-colors duration-350 ease-in-out p-1 focus-visible:!outline-primary-white flex",
      "aria-label": t("header.search.button")
    }, /*#__PURE__*/React.createElement(Search, {
      className: "h-4 w-4",
      "aria-hidden": true
    })), /*#__PURE__*/React.createElement(DesktopSearchContent, {
      isSearchOpen: open,
      setIsSearchOpen: setIsSearchOpen,
      close: close
    }));
  });
};
export var Header = function Header(param) {
  var _param_hideHeader = param.hideHeader,
    hideHeader = _param_hideHeader === void 0 ? false : _param_hideHeader,
    _param_hideCallToActionInHeader = param.hideCallToActionInHeader,
    hideCallToActionInHeader = _param_hideCallToActionInHeader === void 0 ? false : _param_hideCallToActionInHeader;
  var domain = useDomain();
  var _useOperation = useOperation(AllMenusQuery),
    menus = _useOperation.data;
  var _useTranslation = useTranslation(),
    _useTranslation_i18n = _useTranslation.i18n,
    locale = _useTranslation_i18n.language;
  var mainMenuItems = menuItems(domain.sidebarMenu || "main", menus, locale);
  var metaNavigationMenuItems = menuItems(domain.metaNavigationMenu || "meta-navigation", menus, locale);
  var metaNavigationMenuItemsLeft = menuItems("meta-navigation-left", menus, locale);
  var _useState = _sliced_to_array(useState(false), 2),
    isMobileNavigationOpen = _useState[0],
    setIsMobileNavigationOpen = _useState[1];
  var primaryCallToAction = useCallToAction("primary");
  var showMobileHeaderCTAs = domain.showHeaderCTAs && !hideCallToActionInHeader && !hideHeader && !!primaryCallToAction;
  var t = useTranslation().t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SkipNavigation, null), /*#__PURE__*/React.createElement("header", {
    className: "absolute top-0 z-20 md:z-10 inset-x-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-10 lg:block hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-content"
  }, /*#__PURE__*/React.createElement(DesktopMenu, {
    hideCallToActionInHeader: hideCallToActionInHeader,
    hideHeader: hideHeader,
    metaNavigationItems: metaNavigationMenuItems,
    metaNavigationItemsLeft: metaNavigationMenuItemsLeft,
    menuItems: mainMenuItems
  }))), /*#__PURE__*/React.createElement("div", {
    className: "lg:hidden"
  }, /*#__PURE__*/React.createElement(motion.div, {
    animate: isMobileNavigationOpen ? "open" : "closed",
    initial: "closed",
    className: "container-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row gap-2 w-full justify-between body-has-theme-[default]:pt-4"
  }, domain.id === "paraplegie_ch" ? /*#__PURE__*/React.createElement(MobileCompactLogo, null) : /*#__PURE__*/React.createElement(OrganizationLogo, {
    variant: "mobile"
  }), !hideHeader && /*#__PURE__*/React.createElement(MobileMenuButton, {
    isOpen: isMobileNavigationOpen,
    onClick: function onClick() {
      return setIsMobileNavigationOpen(!isMobileNavigationOpen);
    }
  })), !hideHeader && /*#__PURE__*/React.createElement(MobileMenu, {
    menuItems: mainMenuItems,
    metaNavigationItems: metaNavigationMenuItems,
    metaNavigationItemsLeft: metaNavigationMenuItemsLeft,
    isOpen: isMobileNavigationOpen,
    setIsOpen: setIsMobileNavigationOpen
  })))), showMobileHeaderCTAs && /*#__PURE__*/React.createElement(StickyCTA, {
    firstCTA: {
      href: primaryCallToAction.url,
      icon: /*#__PURE__*/React.createElement(primaryCallToAction.icon, null),
      children: t("cta.button_type.".concat(primaryCallToAction.type))
    }
  }));
};
var SkipNavigation = function SkipNavigation() {
  var t = useTranslation().t;
  return /*#__PURE__*/React.createElement("a", {
    href: "#main-content",
    className: "sr-only font-juneau fixed top-0 left-1/2 z-[100] -translate-x-1/2 rounded-sm text-primary-white focus:not-sr-only focus:fixed focus:inline-block focus:bg-theme-dark focus:px-3 focus:py-1"
  }, t("Skip to content"));
};
var DesktopMenu = function DesktopMenu(param) {
  var menuItems = param.menuItems,
    metaNavigationItems = param.metaNavigationItems,
    metaNavigationItemsLeft = param.metaNavigationItemsLeft,
    hideHeader = param.hideHeader,
    hideCallToActionInHeader = param.hideCallToActionInHeader;
  // measuring the height of the content panel to animate the change in it
  var _useMeasure = _sliced_to_array(useMeasure(), 2),
    measureRef = _useMeasure[0],
    bounds = _useMeasure[1];
  var _useState = _sliced_to_array(useState(null), 2),
    openMenuItem = _useState[0],
    setOpenMenuItem = _useState[1];
  var hasEnabledChildItems = useCallback(function (item) {
    var _item_childItems;
    return item === null || item === void 0 ? void 0 : (_item_childItems = item.childItems) === null || _item_childItems === void 0 ? void 0 : _item_childItems.some(function (child) {
      var _child_attributes;
      return !!((_child_attributes = child.attributes) === null || _child_attributes === void 0 ? void 0 : _child_attributes.enabled);
    });
  }, []);
  var primaryCallToAction = useCallToAction("primary");
  var secondaryCallToAction = useCallToAction("secondary");
  var domain = useDomain();
  var hasAnyCallToAction = domain.id === "paraplegie_ch" && !hideCallToActionInHeader && !hideHeader && (!!primaryCallToAction || !!secondaryCallToAction);
  var _useState1 = _sliced_to_array(useState(false), 2),
    isSearchOpen = _useState1[0],
    setIsSearchOpen = _useState1[1];
  return /*#__PURE__*/React.createElement("div", null, !hideHeader && /*#__PURE__*/React.createElement(DesktopMetaNavigationMenu, {
    items: metaNavigationItems,
    itemsLeft: metaNavigationItemsLeft,
    isMainMenuOpen: !!openMenuItem,
    setIsSearchOpen: setIsSearchOpen,
    isSearchOpen: isSearchOpen
  }), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-[auto_1fr_auto] ps-10 items-center"
  }, /*#__PURE__*/React.createElement(DesktopLogo, {
    isAnyPopoverOpen: !!openMenuItem || isSearchOpen,
    hideHeader: hideHeader
  }), /*#__PURE__*/React.createElement(NavigationMenu.Root, {
    onValueChange: function onValueChange(value) {
      if (value === "" || !value) {
        setOpenMenuItem(null);
      }
    },
    "aria-label": "Main navigation menu",
    "aria-hidden": hideHeader,
    className: clsx("flex flex-row justify-between gap-4 items-center", hideHeader && "hidden")
  }, /*#__PURE__*/React.createElement(NavigationMenu.List, {
    className: "flex flex-row gap-x-3 gap-y-2 h-fit items-baseline flex-wrap relative z-20"
  }, menuItems.filter(function (item) {
    var _item_attributes;
    return !!((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.enabled);
  }).map(function (item) {
    var hasChildItems = hasEnabledChildItems(item);
    if (!hasChildItems) {
      return /*#__PURE__*/React.createElement("li", {
        key: item.id
      }, /*#__PURE__*/React.createElement(Link, {
        href: item.url,
        className: clsx("text-16 leading-100% font-juneau font-bold px-1 py-1.5 rounded-1.25 hover:bg-primary-dark-grey hover:text-primary-white flex focus-visible:!-outline-offset-2 transition-colors ease-in-out duration-300", openMenuItem || isSearchOpen ? "text-primary-black" : "", !openMenuItem && !isSearchOpen ? "text-theme-text focus-visible:!outline-theme-text" : "")
      }, item.title));
    }
    return /*#__PURE__*/React.createElement(NavigationMenu.Item, {
      key: item.id
    }, /*#__PURE__*/React.createElement(NavigationMenu.Trigger, {
      //preventing the default hover trigger
      onPointerMove: function onPointerMove(e) {
        e.preventDefault();
      },
      onPointerLeave: function onPointerLeave(e) {
        e.preventDefault();
      },
      className: clsx("text-16 leading-100% font-juneau font-bold px-1 py-1.5 rounded-1.25 hover:bg-primary-dark-grey hover:text-primary-white flex transition-colors ease-in-out duration-300", {
        "text-primary-black": !!openMenuItem || isSearchOpen,
        "bg-primary-dark-grey text-primary-white": openMenuItem === item.id,
        "text-theme-text focus-visible:!outline-theme-text": !openMenuItem && !isSearchOpen
      }),
      onClick: function onClick() {
        if (item.id === openMenuItem) {
          setOpenMenuItem(null);
        } else {
          setOpenMenuItem(item.id);
        }
      }
    }, item.title), item.id === openMenuItem && /*#__PURE__*/React.createElement(NavigationMenu.Content, {
      //preventing the default hover trigger
      onPointerEnter: function onPointerEnter(e) {
        e.preventDefault();
      },
      onPointerLeave: function onPointerLeave(e) {
        e.preventDefault();
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      },
      className: "min-h-80"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "invisible",
      "aria-hidden": true
    }, /*#__PURE__*/React.createElement(DesktopMenu, {
      hideHeader: hideHeader,
      metaNavigationItems: metaNavigationItems,
      metaNavigationItemsLeft: metaNavigationItemsLeft,
      menuItems: menuItems,
      hideCallToActionInHeader: hideCallToActionInHeader
    })), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-[auto_1fr_auto] ps-10 items-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "invisible",
      "aria-hidden": true
    }, /*#__PURE__*/React.createElement(DesktopLogo, {
      isAnyPopoverOpen: !!openMenuItem,
      hideHeader: hideHeader
    })), /*#__PURE__*/React.createElement(motion.div, {
      initial: {
        opacity: 0,
        y: 10
      },
      animate: {
        opacity: 1,
        y: 0
      },
      transition: {
        duration: 0.3,
        ease: "easeInOut",
        bounce: 0.5,
        type: "spring",
        stiffness: 150,
        damping: 15,
        delay: 0.1
      },
      className: "overflow-hidden"
    }, /*#__PURE__*/React.createElement(DesktopHeaderMenuItem, item)), hasAnyCallToAction && /*#__PURE__*/React.createElement("div", {
      className: "pt-2"
    }, /*#__PURE__*/React.createElement(DesktopMenuCloseButton, {
      animate: false,
      isMenuOpen: !!openMenuItem,
      onClick: function onClick() {
        return setOpenMenuItem(null);
      }
    }))))));
  })), /*#__PURE__*/React.createElement(HeaderCTAs, {
    hideHeader: hideHeader,
    hideCallToActionInHeader: hideCallToActionInHeader,
    fallback: /*#__PURE__*/React.createElement(DesktopMenuCloseButton, {
      isMenuOpen: !!openMenuItem || isSearchOpen,
      onClick: isSearchOpen ? function () {
        return setIsSearchOpen(false);
      } : function () {
        return setOpenMenuItem(null);
      }
    })
  }), /*#__PURE__*/React.createElement(AnimatePresence, null, openMenuItem && /*#__PURE__*/React.createElement(motion.div, {
    className: "absolute top-0 inset-x-5 -z-[1] shadow-nav-flyout overflow-hidden rounded-b-20 bg-primary-beige-light",
    key: "header-menu",
    initial: "initialMenu",
    animate: "openMenu",
    exit: "closedMenu",
    variants: {
      initialMenu: {
        height: 0,
        opacity: 0
      },
      openMenu: {
        height: bounds.height,
        opacity: 1
      },
      closedMenu: {
        height: 0,
        opacity: 0,
        transition: {
          duration: 0.4,
          type: "tween",
          opacity: {
            delay: 0.2
          }
        }
      }
    },
    transition: {
      ease: "easeInOut",
      type: "spring",
      stiffness: 150,
      damping: 15
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: measureRef,
    className: "px-5 -mt-4 body-has-theme-[default]:mt-0"
  }, /*#__PURE__*/React.createElement(NavigationMenu.Viewport, {
    forceMount: true
  })))))), isSearchOpen && hasAnyCallToAction && /*#__PURE__*/React.createElement("div", {
    className: "grid justify-end pt-2"
  }, /*#__PURE__*/React.createElement(DesktopMenuCloseButton, {
    isMenuOpen: isSearchOpen,
    onClick: function onClick() {
      return setIsSearchOpen(false);
    }
  })));
};
var DesktopMenuCloseButton = function DesktopMenuCloseButton(param) {
  var onClick = param.onClick,
    isMenuOpen = param.isMenuOpen,
    _param_animate = param.animate,
    animate = _param_animate === void 0 ? true : _param_animate;
  return /*#__PURE__*/React.createElement(AnimatePresence, null, isMenuOpen ? /*#__PURE__*/React.createElement(motion.button, {
    className: "flex flex-row items-center gap-2 text-primary-dark-grey hover:text-theme-action transition-colors duration-350 ease-in-out relative z-20 focus-visible:!-outline-offset-[2px] rounded-1.25",
    "aria-label": "Close main navigation menu",
    onClick: onClick,
    initial: {
      opacity: animate ? 0 : 1
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: animate ? 0 : 1
    },
    transition: {
      duration: 0.3
    }
  }, /*#__PURE__*/React.createElement(X, {
    className: "h-9 w-9 stroke-[1.5]",
    "aria-hidden": "true"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "h-9 w-9 invisible",
    "aria-hidden": true
  }));
};
var ScrollableContainer = function ScrollableContainer(param) {
  var children = param.children,
    className = param.className;
  var _useState = _sliced_to_array(useState(false), 2),
    isScrollable = _useState[0],
    setIsScrollable = _useState[1];
  var menuRef = useRef(null);
  useEffect(function () {
    var checkScrollable = function checkScrollable() {
      if (menuRef.current) {
        var _menuRef_current = menuRef.current,
          scrollHeight = _menuRef_current.scrollHeight,
          clientHeight = _menuRef_current.clientHeight;
        setIsScrollable(scrollHeight > clientHeight);
      }
    };
    checkScrollable();
    window.addEventListener("resize", checkScrollable);
    return function () {
      return window.removeEventListener("resize", checkScrollable);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "relative pb-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx("relative max-h-[calc(70vh-2rem)] overflow-y-auto scrollbar-thumb-primary-dark-grey scrollbar-track-transparent scrollbar-w-1 scrollbar scrollbar-thumb-rounded-full overflow-x-hidden pe-5 ps-1", {
      className: className
    }),
    ref: menuRef
  }, children), /*#__PURE__*/React.createElement(AnimatePresence, null, isScrollable && /*#__PURE__*/React.createElement(motion.div, {
    className: "absolute bottom-0 left-0 right-0 flex justify-center pb-1 pointer-events-none",
    initial: {
      opacity: 0,
      y: -10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: -10
    },
    transition: {
      type: "spring",
      stiffness: 200,
      damping: 20,
      delay: 0.3
    }
  }, /*#__PURE__*/React.createElement(ChevronsDown, {
    size: 24,
    className: "text-theme-action",
    "aria-hidden": true
  }))));
};
function NavigationMenuLink(props) {
  var _useLocation = _sliced_to_array(useLocation(), 2),
    navigate = _useLocation[1];
  return /*#__PURE__*/React.createElement(NavigationMenu.Link, _object_spread_props(_object_spread({}, props), {
    onClick: function onClick(ev) {
      ev.preventDefault();
      navigate(props.href);
    }
  }));
}
var DesktopHeaderMenuItem = function DesktopHeaderMenuItem(param) {
  var title = param.title,
    childItems = param.childItems,
    url = param.url,
    id = param.id;
  var _useState = _sliced_to_array(useState(undefined), 2),
    selectedItem = _useState[0],
    setSelectedItem = _useState[1];
  return /*#__PURE__*/React.createElement(NavigationMenu.Sub, {
    defaultValue: undefined,
    className: "flex flex-row ",
    orientation: "vertical"
  }, /*#__PURE__*/React.createElement(ScrollableContainer, null, /*#__PURE__*/React.createElement(NavigationMenu.List, {
    "aria-label": "".concat(title, " sub-menu")
  }, /*#__PURE__*/React.createElement(NavigationMenu.Item, {
    value: id,
    className: "link-outer-focus my-1.5"
  }, /*#__PURE__*/React.createElement(NavigationMenuLink, {
    href: url !== null && url !== void 0 ? url : "/",
    className: "text-18 font-juneau font-bold leading-100% text-primary-black border-solid min-w-72 w-full py-2.5 flex px-1"
  }, title)), childItems === null || childItems === void 0 ? void 0 : childItems.filter(function (item) {
    var _item_attributes;
    return !!(item === null || item === void 0 ? void 0 : (_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.enabled);
  }).map(function (childItem) {
    var _childItem_childItems, _childItem_childItems1;
    var _childItem_childItems_filter_length;
    var hasChildItems = ((_childItem_childItems_filter_length = (_childItem_childItems = childItem.childItems) === null || _childItem_childItems === void 0 ? void 0 : _childItem_childItems.filter(function (item) {
      var _item_attributes;
      return !!(item === null || item === void 0 ? void 0 : (_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.enabled);
    }).length) !== null && _childItem_childItems_filter_length !== void 0 ? _childItem_childItems_filter_length : 0) > 0;
    var _childItem_url;
    return hasChildItems ? /*#__PURE__*/React.createElement(NavigationMenu.Item, {
      value: childItem.id,
      key: childItem.id,
      className: "link-outer-focus"
    }, /*#__PURE__*/React.createElement(NavigationMenu.Trigger, {
      className: clsx("flex flex-row items-center justify-between py-2.5 px-1 text-14 leading-120% font-juneau font-bold hover:bg-theme-light/30  text-primary-black border-solid border-t border-primary-beige/20 min-w-72 transition-colors duration-250 ease-in-out w-full text-start", {
        "bg-theme-light/30": selectedItem === childItem.id
      }),
      onPointerMove: function onPointerMove(e) {
        e.preventDefault();
      },
      onPointerLeave: function onPointerLeave(e) {
        e.preventDefault();
      },
      onClick: function onClick() {
        if (selectedItem === childItem.id) {
          setSelectedItem(undefined);
        } else {
          setSelectedItem(childItem.id);
        }
      }
    }, /*#__PURE__*/React.createElement("span", null, childItem.title), /*#__PURE__*/React.createElement(ChevronRight, {
      className: "ml-1.5 h-4 w-4 min-h-4 min-w-4",
      "aria-hidden": true
    })), selectedItem === childItem.id && /*#__PURE__*/React.createElement(NavigationMenu.Content, {
      onPointerEnter: function onPointerEnter(e) {
        e.preventDefault();
      },
      onPointerLeave: function onPointerLeave(e) {
        e.preventDefault();
      }
    }, /*#__PURE__*/React.createElement(motion.div, {
      initial: {
        opacity: 0,
        x: -10
      },
      animate: {
        opacity: 1,
        x: 0
      },
      transition: {
        duration: 0.3,
        ease: "easeInOut",
        bounce: 0.5,
        type: "spring",
        stiffness: 150,
        damping: 15,
        delay: 0.1
      },
      className: "overflow-x-hidden pe-5"
    }, /*#__PURE__*/React.createElement(ScrollableContainer, null, /*#__PURE__*/React.createElement("ul", {
      className: "flex flex-col text-primary-black w-fit ms-10 border-b border-primary-beige/20 border-solid",
      "aria-label": "".concat(childItem.title, " sub-menu")
    }, /*#__PURE__*/React.createElement("li", {
      className: "flex link-outer-focus my-1.5"
    }, /*#__PURE__*/React.createElement(NavigationMenuLink, {
      className: "text-18 font-juneau font-bold leading-100% w-max max-w-[30vw] py-2.5 flex px-1 text-start",
      href: (_childItem_url = childItem.url) !== null && _childItem_url !== void 0 ? _childItem_url : "/"
    }, childItem.title)), (_childItem_childItems1 = childItem.childItems) === null || _childItem_childItems1 === void 0 ? void 0 : _childItem_childItems1.filter(function (item) {
      var _item_attributes;
      return !!((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.enabled);
    }).map(function (subItem) {
      return /*#__PURE__*/React.createElement("li", {
        key: subItem.id,
        className: "flex link-outer-focus"
      }, /*#__PURE__*/React.createElement(Link, {
        href: subItem.url || "#",
        className: clsx("flex flex-1 py-2.5 px-1 text-14 leading-120% font-juneau font-bold hover:bg-theme-light/30  text-primary-black min-w-72 border-solid border-t border-primary-beige/20 transition-colors duration-250 ease-in-out w-max max-w-[30vw] text-start")
      }, subItem.title));
    })))))) : /*#__PURE__*/React.createElement("li", {
      key: childItem.id,
      className: "flex link-outer-focus"
    }, /*#__PURE__*/React.createElement(NavigationMenuLink, {
      key: childItem.id,
      href: childItem.url || "#",
      className: "flex text-14 font-juneau font-bold leading-120% px-1 py-2.5 hover:bg-theme-light/30  text-primary-black border-solid border-t border-primary-beige/20 min-w-72 w-full text-start"
    }, childItem.title));
  }), /*#__PURE__*/React.createElement("div", {
    className: "border-b border-primary-beige/20 border-solid"
  }))), /*#__PURE__*/React.createElement(NavigationMenu.Viewport, {
    forceMount: true
  }));
};
var MobileMenu = function MobileMenu(param) {
  var menuItems = param.menuItems,
    metaNavigationItems = param.metaNavigationItems,
    metaNavigationItemsLeft = param.metaNavigationItemsLeft,
    isOpen = param.isOpen,
    setIsOpen = param.setIsOpen;
  return /*#__PURE__*/React.createElement(AnimatePresence, null, isOpen && /*#__PURE__*/React.createElement(LinkClickHandler, {
    onLinkClick: function onLinkClick() {
      return setIsOpen(false);
    }
  }, /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    },
    static: true,
    className: "relative z-50"
  }, /*#__PURE__*/React.createElement(DialogPanel, {
    as: Fragment
  }, /*#__PURE__*/React.createElement(motion.div, {
    initial: "initial",
    animate: "open",
    exit: "closed",
    variants: {
      initial: {
        clipPath: "circle(48px at calc(100% - 32px) 32px)",
        opacity: 1
      },
      open: {
        clipPath: "circle(150% at calc(100% - 32px) 32px)",
        opacity: 1
      },
      closed: {
        clipPath: "circle(48px at calc(100% - 32px) 32px)",
        opacity: 0,
        transition: {
          duration: 0.5,
          ease: [0.4, 0, 0.2, 1],
          opacity: {
            delay: 0.2,
            duration: 0.2
          }
        }
      }
    },
    transition: {
      duration: 0.5,
      ease: [0.4, 0, 0.2, 1]
    },
    className: "fixed inset-0 z-50 bg-theme-light body-has-theme-[default]:bg-primary-beige-light body-has-theme-[sps]:bg-primary-beige-light overflow-y-auto"
  }, /*#__PURE__*/React.createElement(motion.div, {
    initial: "closed",
    animate: "open",
    exit: "closed",
    className: "pb-5 flex flex-row gap-2 justify-between container-page body-has-theme-[default]:pt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "block body-has-theme-[default]:hidden"
  }, /*#__PURE__*/React.createElement(OrganizationLogo, {
    variant: "mobile"
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden body-has-theme-[default]:block"
  }, /*#__PURE__*/React.createElement(MobileCompactLogo, {
    variant: "colored"
  })), /*#__PURE__*/React.createElement(MobileMenuButton, {
    isOpen: isOpen,
    onClick: function onClick() {
      return setIsOpen(false);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-page"
  }, /*#__PURE__*/React.createElement(SearchForm, {
    onSubmit: function onSubmit() {
      return setIsOpen(false);
    }
  })), /*#__PURE__*/React.createElement("nav", {
    className: "container-page",
    "aria-label": "Main Navigation Menu"
  }, /*#__PURE__*/React.createElement(MobileNavigationItem, {
    isRoot: true,
    childItems: menuItems
  })), /*#__PURE__*/React.createElement("div", {
    className: "border-t border-primary-beige/20 border-solid pb-10 container-page"
  }), /*#__PURE__*/React.createElement(MobileMetaNavigationMenu, {
    items: metaNavigationItems,
    itemsLeft: metaNavigationItemsLeft,
    onLanguageChange: function onLanguageChange() {
      return setIsOpen(false);
    }
  })))))));
};
var MobileNavigationItem = function MobileNavigationItem(props) {
  var _props_parent, _props_childItems;
  var _useState = _sliced_to_array(useState(false), 2),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  return /*#__PURE__*/React.createElement("ul", {
    className: "relative text-primary-black"
  }, !isOpen && !props.isRoot && /*#__PURE__*/React.createElement("li", {
    className: "link-outer-focus"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    className: "flex flex-row items-center w-full font-juneau text-14 leading-120% gap-1 py-5 -ml-1 "
  }, /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "h-4 w-4"
  }), !props.parent ? "Back" : (_props_parent = props.parent) === null || _props_parent === void 0 ? void 0 : _props_parent.title)), !isOpen && !props.isRoot && /*#__PURE__*/React.createElement("li", {
    className: "link-outer-focus"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "font-juneau text-18 font-bold leading-120% pb-4 flex",
    href: props.item.url
  }, props.item.title)), (_props_childItems = props.childItems) === null || _props_childItems === void 0 ? void 0 : _props_childItems.filter(function (item) {
    var _item_attributes;
    return !!((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.enabled);
  }).map(function (item) /*#__PURE__*/{
    var _item_childItems;
    var _item_childItems_filter_length, _item_url;
    return React.createElement("li", {
      key: item.id
    }, ((_item_childItems_filter_length = (_item_childItems = item.childItems) === null || _item_childItems === void 0 ? void 0 : _item_childItems.filter(function (item) {
      var _item_attributes;
      return !!((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.enabled);
    }).length) !== null && _item_childItems_filter_length !== void 0 ? _item_childItems_filter_length : 0) > 0 ? /*#__PURE__*/React.createElement(Disclosure, {
      key: item.id
    }, function (param) {
      var open = param.open;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !isOpen && /*#__PURE__*/React.createElement("div", {
        className: "link-outer-focus"
      }, /*#__PURE__*/React.createElement(DisclosureButton, {
        className: "flex flex-row items-center justify-between w-full font-juneau text-14 leading-120% font-bold border-t border-primary-beige/20 border-solid py-4"
      }, item.title, /*#__PURE__*/React.createElement(ChevronRight, {
        className: "h-4 w-4 min-h-4 min-w-4",
        "aria-hidden": true
      }))), /*#__PURE__*/React.createElement(Transition, {
        show: open,
        beforeEnter: function beforeEnter() {
          setIsOpen(true);
        },
        beforeLeave: function beforeLeave() {
          setIsOpen(false);
        }
      }, /*#__PURE__*/React.createElement(DisclosurePanel, null, /*#__PURE__*/React.createElement(MobileNavigationItem, {
        item: item,
        childItems: item.childItems,
        isRoot: false,
        parent: props.isRoot ? undefined : props.item
      }))));
    }) : /*#__PURE__*/React.createElement("div", {
      className: "link-outer-focus"
    }, /*#__PURE__*/React.createElement(Link, {
      href: (_item_url = item.url) !== null && _item_url !== void 0 ? _item_url : "/",
      className: "flex flex-row items-center justify-between w-full font-juneau text-14 leading-120% font-bold border-t border-primary-beige/20 py-4 border-solid "
    }, item.title)));
  }));
};
var DesktopMetaNavigationMenu = function DesktopMetaNavigationMenu(props) {
  var locale = useLocalization().locale;
  var domain = useDomain();
  return /*#__PURE__*/React.createElement("nav", {
    className: clsx("w-full bg-primary-dark-grey rounded-full shadow-meta-nav mt-6 body-has-theme-[default]:mb-7 px-10 text-primary-white justify-between inline-flex items-center py-3"),
    "aria-label": "Meta Navigation Menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center"
  }, /*#__PURE__*/React.createElement(LogoCompactSvg, {
    className: "h-4 w-4"
  }), /*#__PURE__*/React.createElement("ul", {
    className: "flex flex-row items-center"
  }, props.itemsLeft.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.id
    }, /*#__PURE__*/React.createElement(Link, {
      href: item.url,
      className: "text-14 font-juneau leading-100% ms-1 focus-visible:!outline-primary-white p-1 hover:bg-primary-white rounded-1.25 hover:text-primary-black transition-colors duration-350 ease-in-out"
    }, item.title));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center gap-3"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "flex flex-row items-center gap-3"
  }, props.items.map(function (item) {
    var _item_attributes, _item_attributes1;
    return ((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.id) !== "search" && /*#__PURE__*/React.createElement("li", {
      key: item.id,
      className: "flex"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "text-14 font-juneau leading-100% ms-1 focus-visible:!outline-primary-white p-1 hover:bg-primary-white rounded-1.25 hover:text-primary-black transition-colors duration-350 ease-in-out",
      href: ((_item_attributes1 = item.attributes) === null || _item_attributes1 === void 0 ? void 0 : _item_attributes1.id) === "contact" ? getContactUrl(item.url, domain, locale) : item.url
    }, item.title));
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-1 text-14 leading-100% text-primary-white/10"
  }, "|"), /*#__PURE__*/React.createElement(LanguageSwitcher, {
    variant: "desktop"
  }), /*#__PURE__*/React.createElement(DesktopSearch, {
    isMenuOpen: props.isMainMenuOpen,
    setIsSearchOpen: props.setIsSearchOpen
  }))));
};
var MobileMetaNavigationMenu = function MobileMetaNavigationMenu(props) {
  var locale = useLocalization().locale;
  var domain = useDomain();
  return /*#__PURE__*/React.createElement("nav", {
    className: "bg-primary-dark-grey text-primary-white justify-between inline-flex items-center relative pt-10 container-page w-full pb-8 flex-col",
    "aria-label": "Meta Navigation Menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-8 min-h-8 w-auto mb-7 -mt-2 block body-has-theme-[default]:hidden focus-within:outline-primary-white focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline rounded-1 "
  }, /*#__PURE__*/React.createElement(Logo, {
    variant: "default-white",
    size: "small"
  })), /*#__PURE__*/React.createElement("ul", {
    className: "font-juneau text-14 leading-100% font-bold text-primary-white last:border-b border-primary-beige/20 border-solid w-full"
  }, props.itemsLeft.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.id,
      className: "link-outer-focus focus-within:!outline-primary-white"
    }, /*#__PURE__*/React.createElement(Link, {
      href: item.url,
      className: "py-3 border-t border-primary-beige/20 border-solid flex"
    }, item.title));
  }), props.items.map(function (item) {
    var _item_attributes, _item_attributes1;
    return ((_item_attributes = item.attributes) === null || _item_attributes === void 0 ? void 0 : _item_attributes.id) !== "search" && /*#__PURE__*/React.createElement("li", {
      key: item.id,
      className: "link-outer-focus focus-within:!outline-primary-white"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "py-3 border-t border-primary-beige/20 border-solid flex",
      href: ((_item_attributes1 = item.attributes) === null || _item_attributes1 === void 0 ? void 0 : _item_attributes1.id) === "contact" ? getContactUrl(item.url, domain, locale) : item.url
    }, item.title));
  }))), /*#__PURE__*/React.createElement("div", {
    className: " w-full py-8"
  }, /*#__PURE__*/React.createElement(LanguageSwitcher, {
    variant: "mobile",
    onLanguageChange: props.onLanguageChange
  })));
};
var languageSchema = z.object({
  language: z.nativeEnum(Locale)
});
var LanguageSwitcher = function LanguageSwitcher(props) {
  var _useLocalization = useLocalization(),
    locales = _useLocalization.locales,
    locale = _useLocalization.locale;
  var t = useTranslation().t;
  var translationsMap = usePageTranslations();
  var translations = Object.fromEntries(translationsMap);
  var _useLocation = _sliced_to_array(useLocation(), 2),
    navigate = _useLocation[1];
  var _useForm = useForm({
      resolver: zodResolver(languageSchema),
      defaultValues: {
        language: locale
      }
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control,
    reset = _useForm.reset;
  // Reset form when the locale changes.
  useEffect(function () {
    reset({
      language: locale
    });
  }, [locale, reset]);
  var onSubmit = function onSubmit(data) {
    navigate(getLocalizedUrl({
      to: translations[data.language] || "/",
      locale: data.language
    }).url);
    props.variant === "mobile" && props.onLanguageChange();
  };
  if (props.variant === "desktop") {
    return /*#__PURE__*/React.createElement(Controller, {
      control: control,
      name: "language",
      render: function render(param) {
        var field = param.field;
        return /*#__PURE__*/React.createElement(Listbox, {
          value: field.value,
          onChange: function onChange(value) {
            field.onChange(value);
            handleSubmit(onSubmit)();
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "relative"
        }, /*#__PURE__*/React.createElement(ListboxButton, {
          className: "flex items-center text-14 leading-100% p-1 rounded-1.25 font-juneau hover:bg-primary-white hover:text-primary-black transition-colors duration-350 ease-in-out focus-visible:!outline-primary-white focus-visible:!outline-2 focus-visible:outline focus-visible:!outline-offset-2 relative min-w-[26px] text-center justify-center"
        }, /*#__PURE__*/React.createElement("span", null, field.value.toUpperCase())), /*#__PURE__*/React.createElement(ListboxOptions, {
          transition: true,
          className: "w-fit rounded-lg p-3 [--anchor-gap:-50px] origin-top transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0  bg-primary-dark-grey z-20 focus:!outline-none flex items-center justify-center flex-col gap-2.5 shadow-language-menu",
          anchor: "top",
          modal: false
        }, Object.values(locales).map(function (param) {
          var code = param.code;
          return Object.keys(translations).includes(code) && /*#__PURE__*/React.createElement(ListboxOption, {
            key: code,
            value: code,
            className: function className() {
              return clsx("relative cursor-pointer py-0.5 px-1 text-14 leading-100% font-juneau text-primary-white  data-[selected]:bg-primary-white data-[selected]:text-primary-dark-grey transition-colors duration-200 ease-in-out hover:bg-primary-white hover:text-primary-dark-grey rounded-1 text-center items-center justify-center flex w-full flex-1 data-[focus]:bg-primary-white data-[focus]:text-primary-dark-grey");
            }
          }, code.toUpperCase());
        }))));
      }
    });
  }
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSubmit),
    className: "focus-within:outline-primary-white focus-within:outline-2 focus-within:outline focus-within:outline-offset-2 transition-colors duration-350 ease-in-out inline-flex items-center justify-between text-primary-white relative w-full rounded-full border-solid border-2 border-primary-white ps-7 pe-4 h-12"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "language-select",
    className: "absolute -top-2 left-6 bg-primary-dark-grey text-primary-white px-1 text-12 leading-100% font-juneau"
  }, t("Language")), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "language",
    render: function render(param) {
      var field = param.field;
      return /*#__PURE__*/React.createElement(Select, _object_spread_props(_object_spread({}, field), {
        id: "language-select",
        name: "language",
        "aria-label": "Language Switcher",
        className: "text-16 leading-160% p-0 w-full block appearance-none !border-0 focus:!border-0 focus:ring-0 focus:!outline-none cursor-pointer !bg-none !bg-transparent text-inherit",
        onChange: function onChange(e) {
          field.onChange(e);
          handleSubmit(onSubmit)();
        }
      }), Object.values(locales).map(function (param) {
        var code = param.code,
          name = param.name;
        return Object.keys(translations).includes(code) && /*#__PURE__*/React.createElement("option", {
          key: code,
          value: code
        }, name);
      }));
    }
  }), /*#__PURE__*/React.createElement(ChevronDown, {
    className: "w-4 h-4",
    "aria-hidden": "true"
  }));
};
var MobileMenuButton = function MobileMenuButton(param) {
  var isOpen = param.isOpen,
    onClick = param.onClick;
  var _useState = _sliced_to_array(useState(false), 2),
    hasBackground = _useState[0],
    setHasBackground = _useState[1];
  var _useLocation = _sliced_to_array(useLocation(), 1),
    location = _useLocation[0];
  useEffect(function () {
    var observer = new IntersectionObserver(function (param) {
      var _param = _sliced_to_array(param, 1),
        entry = _param[0];
      setHasBackground(!entry.isIntersecting);
    }, {
      rootMargin: "-60px 0px 0px 0px"
    });
    var heroElement = document.getElementById("header-hero");
    if (heroElement) {
      observer.observe(heroElement);
    }
    return function () {
      if (heroElement) {
        observer.unobserve(heroElement);
      }
    };
  }, [location.pathname]);
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: clsx("transition-colors duration-300 ease-in-out right-0 top-0 px-4 py-6 rounded-bl-xl", {
      "text-primary-black  absolute ": isOpen,
      "text-theme-text fixed z-50 ": !isOpen,
      "bg-theme-menu-reverse": hasBackground && !isOpen
    }),
    "aria-label": isOpen ? "Close navigation menu" : "Open navigation menu"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement(motion.path, {
    strokeWidth: "2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    variants: {
      closed: {
        d: "M1 4L20 4"
      },
      open: {
        d: "M20 1L1 20"
      }
    }
  }), /*#__PURE__*/React.createElement(motion.path, {
    strokeWidth: "2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    variants: {
      closed: {
        d: "M1 12L13 12"
      },
      open: {
        d: "M-1 12L-1 12"
      }
    }
  }), /*#__PURE__*/React.createElement(motion.path, {
    strokeWidth: "2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    variants: {
      closed: {
        d: "M1 20L20 20"
      },
      open: {
        d: "M1 1L20 20"
      }
    }
  })));
};
var DesktopLogo = function DesktopLogo(param) {
  var isAnyPopoverOpen = param.isAnyPopoverOpen,
    _param_hideHeader = param.hideHeader,
    hideHeader = _param_hideHeader === void 0 ? false : _param_hideHeader;
  var domain = useDomain();
  var _useTranslation = useTranslation(),
    _useTranslation_i18n = _useTranslation.i18n,
    locale = _useTranslation_i18n.language,
    t = _useTranslation.t;
  var homeLink = getLocalizedUrl({
    to: "/",
    locale: locale,
    domain: domain
  }).url;
  return /*#__PURE__*/React.createElement(React.Fragment, null, domain.id === "paraplegie_ch" ? /*#__PURE__*/React.createElement("div", {
    key: "group-logo",
    className: clsx("me-9 h-auto w-auto theme-default z-20 rounded-1.25", {
      "text-primary-white transition-colors duration-350 delay-200 ease-in-out ": !isAnyPopoverOpen && !hideHeader,
      "text-primary-white transition-colors !duration-0 !delay-0": hideHeader,
      "text-theme-dark transition-colors duration-200 ease-in-out": isAnyPopoverOpen && !hideHeader,
      "pt-10": hideHeader
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: homeLink,
    "aria-label": t(domain.title)
  }, /*#__PURE__*/React.createElement(LogoCompactSvg, {
    className: "h-10 w-auto"
  }))) : /*#__PURE__*/React.createElement("div", {
    key: "organization-logo",
    className: clsx("w-fit me-9 z-20 transition-colors duration-300 delay-150 ease-in-out", {
      "text-primary-beige-light": isAnyPopoverOpen,
      "text-primary-white": !isAnyPopoverOpen
    })
  }, /*#__PURE__*/React.createElement(OrganizationLogo, {
    variant: "desktop"
  })));
};
var MobileCompactLogo = function MobileCompactLogo(param) {
  var _param_variant = param.variant,
    variant = _param_variant === void 0 ? "white" : _param_variant;
  var domain = useDomain();
  var locale = useLocalization().locale;
  var t = useTranslation().t;
  var homeLink = getLocalizedUrl({
    to: "/",
    locale: locale,
    domain: domain
  }).url;
  return /*#__PURE__*/React.createElement(Link, {
    key: "mobile-compact-logo",
    className: clsx("flex items-center justify-center rounded-1.25", {
      "text-primary-white": variant === "white",
      "text-theme-dark": variant === "colored"
    }),
    href: homeLink,
    "aria-label": t(domain.title)
  }, /*#__PURE__*/React.createElement(LogoCompactSvg, {
    className: "h-9 w-auto"
  }));
};
var OrganizationLogo = function OrganizationLogo(param) {
  var variant = param.variant;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx("flex items-center justify-center", {
      "bg-current rounded-b-5 h-[97px] w-[210px] p-5": variant === "desktop",
      "bg-primary-white rounded-b-2.5 w-[138px] h-[66px] p-1.5": variant === "mobile"
    })
  }, /*#__PURE__*/React.createElement(Logo, {
    variant: "domain",
    size: variant === "desktop" ? "regular" : "small"
  }));
};